import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { DndContext } from '@dnd-kit/core';
import { css } from '@emotion/react';
import { DragOverlayItem } from './dragOverlayItem';
import { PokerPanelContainer } from './panels/pokerPanelContainer';
import { PokerTableStageContainer } from './pokerTableStageContainer';
const CONTAINER_CSS = css `
  position: relative;
  height: 100%;
  width: 100%;
`;
export const PokerSceneMainDisplay = () => {
    return (_jsxs(DndContext, { children: [_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(PokerTableStageContainer, {}), _jsx(PokerPanelContainer, {})] }), _jsx(DragOverlayItem, {})] }));
};
